/**
 * Badge variant for audit `outcome` (Success / Failed, case-insensitive).
 *
 * @param {string | null | undefined} outcome
 * @returns {'success' | 'danger' | 'neutral'}
 */
export const auditOutcomeBadgeVariant = (outcome) => {
  const o = String(outcome ?? '').toLowerCase();
  if (o === 'success') return 'success';
  if (o === 'failed' || o === 'failure' || o === 'error') return 'danger';
  return 'neutral';
};
